export default {
  filters: {
    numberFormat(value) {
      return Intl.NumberFormat().format(value);
    }
  },
  methods: {
    convertNumberIntoUnicodeCircledNumber(num) {
      if (!Number.isInteger(num) || num < 1) {
        return String(num);
      } else if (num <= 20) {
        num = num + 9311;
      } else if (num >= 21 && num <= 35) {
        num = num + 12881 - 21;
      } else if (num >= 36 && num <=50) {
        num = num + 12977 - 36;
      } else {
        return String(num);
      }
      return String.fromCodePoint(num);
    },
    labelTitle(event) {
      let orderLabel = ''
      if (event.extendedProps.is_step) {
        orderLabel = `STEP ${this.convertNumberIntoUnicodeCircledNumber(event.extendedProps.item_order)} `
      }

      if (event.extendedProps.is_task) {
        orderLabel = `TASK ${this.convertNumberIntoUnicodeCircledNumber(event.extendedProps.item_order)} `
      }

      return `${orderLabel}${event.extendedProps.title}`;
    },
  }
}
